import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ScheduleIcon from "@material-ui/icons/Schedule";
import UpdateIcon from "@material-ui/icons/Update";
import dayjs from "dayjs";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { utcToLocal } from "../../utils/datetime";
import Accordion from "../Accordion";
import styles from "./index.module.scss";

function CoachingDateHistory({ sessionData, sessionDateHistory }) {
  const { t } = useTranslation();
  const [coachingHistory, setCoachingHistory] = useState([]);
  // helper function to get values under "session" in data object
  const getSessionValue = field => {
    return sessionData ? sessionData[field] : undefined;
  };
  useEffect(() => {
    setCoachingHistory(
      _.orderBy(
        sessionDateHistory,
        [
          item => {
            return dayjs(item.previous_coaching_date).format("YYYY-MM-DD");
          },
        ],
        ["desc"]
      )
    );
  }, [sessionDateHistory]);

  return (
    <>
      {coachingHistory.length === 0 && (
        <div className={styles.row}>
          <div className={styles.rowLeft}>
            {t("sessionDetails.caochingDate")}
          </div>
          <div className={styles.rowRight}>
            <span className={styles.rowIcon}>
              <CalendarTodayIcon />
            </span>
            <span style={{ padding: "0 12px 0 4px" }}>
              {/* Time format: 9 Jan 2020 */}
              {dayjs(getSessionValue("session_datetime"))
                .add(dayjs().utcOffset(), "minutes")
                .format("D MMM YYYY")}
            </span>
            <span className={styles.rowIcon}>
              <ScheduleIcon />
            </span>
            <span style={{ padding: "0 12px 0 4px" }}>
              {/* Time format: 8:12 PM*/}
              {dayjs(getSessionValue("session_datetime"))
                .add(dayjs().utcOffset(), "minutes")
                .format("h:mm A")}
            </span>
          </div>
        </div>
      )}
      {coachingHistory && coachingHistory.length > 0 && (
        <Accordion
          summary={
            <div className={styles.reviewDateSummary}>
              <div className={styles.reviewDateSummaryLeft}>
                <span>{t("sessionDetails.caochingDate")}</span>{" "}
                <UpdateIcon color="primary" />
              </div>
              <div className={styles.reviewDateSummaryRight}>
                <div className={styles.reviewDateContent}>
                  <div className={styles.reviewDateContentDateTime}>
                    <div className={styles.date}>
                      <CalendarTodayIcon className={styles.icon} />{" "}
                      <span>
                        {utcToLocal(getSessionValue("session_datetime")).format(
                          "DD MMM YYYY"
                        )}
                      </span>
                    </div>
                    <div className={styles.time}>
                      <ScheduleIcon className={styles.icon} />{" "}
                      <span>
                        {utcToLocal(getSessionValue("session_datetime")).format(
                          "h:mm A"
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          details={
            <div className={styles.reviewDateContent}>
              {coachingHistory &&
                coachingHistory.map((item, index) => (
                  <>
                    <div className={styles.reviewDateContentDescription}>
                      Reason: {item.reason}
                    </div>
                    <div className={styles.reviewDateContentItem} key={`${item.previous_coaching_date}-${index}`}>
                      <div className={styles.reviewDateContentDateTime}>
                        <div className={styles.date}>
                          <CalendarTodayIcon className={styles.icon} />{" "}
                          <span>
                            {utcToLocal(item.previous_coaching_date).format(
                              "DD MMM YYYY"
                            )}
                          </span>
                        </div>
                        <div className={styles.time}>
                          <ScheduleIcon className={styles.icon} />{" "}
                          <span>
                            {utcToLocal(item.previous_coaching_date).format(
                              "h:mm A"
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
            </div>
          }
        />
      )}
    </>
  );
}

export default CoachingDateHistory;
